export enum Layers {
  Sidebar = 10,
  EpgCornerBox = 90,
  Line = 10,
  Loader = 100,
  Program = 1,
  Timeline = 10,
}
